import React, {useState, useEffect, useContext} from 'react';
import {ApiContext} from '../App';
import YouTube, {YouTubeProps} from 'react-youtube';
import '../css/components/Section00.css';
import {useFullPageContext} from "../FullPageContext";


const Section00: React.FC = () => {
    const apiUrl = useContext(ApiContext);
    const [mediaType, setMediaType] = useState<string>('');
    const [videoSrc, setVideoSrc] = useState<string>('');

    const {goToSection} = useFullPageContext();

    const isIPad = /ipad/.test(navigator.userAgent.toLowerCase()) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    const isAndroidTablet = navigator.userAgent.toLowerCase().includes("android") &&
        !navigator.userAgent.toLowerCase().includes("mobile");

    const [isMobile, setIsMobile] = useState(
        (window.innerWidth <= 767 && !isIPad && !isAndroidTablet) || false
    );

    useEffect(() => {
        const handleResize = () => {
            const userAgent = navigator.userAgent.toLowerCase();

            // 아이패드 감지 (아이패드 미니 포함)
            const isIPad = /ipad/.test(userAgent) ||
                (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

            // 안드로이드 태블릿 감지
            const isAndroidTablet = userAgent.includes("android") && !userAgent.includes("mobile");

            // 모바일 상태 판별: 화면 크기 768px 이하이고, 아이패드 또는 안드로이드 태블릿이 아니어야 함
            const isNowMobile = window.innerWidth <= 768 && !isIPad && !isAndroidTablet;

            if (isNowMobile !== isMobile) {
                setIsMobile(isNowMobile);
            }
        };


        const callApi = async ({deviceType}: { deviceType: any }) => {
            try {
                // const endpoint = deviceType === 'Mobile'
                //     ? `${apiUrl}/api/main/thumbnail/mobile`
                //     : `${apiUrl}/api/main/thumbnail/pc`;
                const endpoint = `${apiUrl}/api/main/thumbnail/pc`;

                const response = await fetch(endpoint);

                if (!response.ok) {
                    console.error('Network error:', response.statusText);
                    return;
                }

                const result = await response.json();

                if (result.code == 200 && result.data) {
                    //iframe_link.src =  `${videoSource}?autoplay=1&loop=1&mute=1&playlist=${videoSource.split('/')[4]}`;;
                    const videoSource = result.data.mediaUrl;

                    // mediaType
                    // mediaUrl
                    setMediaType(result.data.mediaType);
                    //src="https://www.youtube.com/embed/영상ID?autoplay=1&rel=0&playsinline=1"
                    // setVideoSrc(result.data.mediaType === 'file' ? result.data.videoFilePath :  `${videoSource}?autoplay=1&rel=0&loop=1&mute=1&playlist=${videoSource.split('/')[4]}`);
                    setVideoSrc(result.data.mediaType === 'file' ? result.data.videoFilePath : `${videoSource}?autoplay=1&rel=0&loop=1&mute=1&playlist=${videoSource.split('/')[4]}`);

                    //autoplay=1&playsinline=1&controls=0&modestbranding=1&rel=0&showinfo=0&mute=1
                    // setVideoSrc(result.data.mediaType === 'file' ? result.data.videoFilePath :  `${videoSource}?autoplay=1&loop=1&mute=1&playlist=${videoSource.split('/')[4]}`);
                } else {
                    console.error('Failed to fetch thumbnail images:', result.message);
                }
            } catch (error) {
                console.error('Error fetching thumbnail images:', error);
            }
        };

        // 초기 상태에 따라 API 호출
        callApi({deviceType: isMobile ? "Mobile" : "PC"});

        window.addEventListener("resize", handleResize);

        // cleanup
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [isMobile]);


    // 초기 상태는 세로모드로 설정
    const [isPortrait, setIsPortrait] = useState<boolean>(true);

    // 화면 방향을 감지하는 함수
    const checkOrientation = () => {
        // window.orientation을 사용하여 세로모드(0) 또는 가로모드(90, -90)를 감지
        if (window.orientation === 0 || window.orientation === 180) {
            setIsPortrait(true); // 세로모드
        } else if (window.orientation === 90 || window.orientation === -90) {
            setIsPortrait(false); // 가로모드
        }
    };

    useEffect(() => {
        // 컴포넌트가 마운트될 때 방향 감지 함수 실행
        checkOrientation();

        // orientationchange 이벤트 리스너를 추가하여 화면 회전 시 방향 변경 감지
        window.addEventListener('orientationchange', checkOrientation);

        // 화면 크기 조정 시에도 방향을 체크하는 resize 이벤트 리스너 추가
        window.addEventListener('resize', checkOrientation);

        // 클린업: 이벤트 리스너 제거
        return () => {
            window.removeEventListener('orientationchange', checkOrientation);
            window.removeEventListener('resize', checkOrientation);
        };
    }, []);

    const VideoPlayer = () => {
        return (
            <div
                style={{
                    // position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    overflow: "hidden", // 넘치는 부분 숨김
                    backgroundColor: "black", // 빈 공간 방지
                }}
            >
                <iframe
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        width: "120vw", // 영상 확대
                        height: "120vh", // 영상 확대
                        transform: "translate(-50%, -50%)", // 중앙 정렬
                        border: "none",
                        pointerEvents: 'none',
                    }}
                    src={videoSrc}
                    title="YouTube video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen;"
                    loading="lazy" // Lazy loading 적용
                    referrerPolicy="no-referrer"
                    allowFullScreen
                ></iframe>
            </div>
        );
    };
    return (
        <div id="prologue">
            <a href="javascript: void(0);" className="m_menus" onClick={() => goToSection(1)}>
                <img src="/image/scroll_with_text.png" alt="Down"/>
            </a>
            <div className="video_box">
                {videoSrc && (mediaType === 'file' ? (
                    <video autoPlay muted loop className="videoPlayer">
                        <source src={videoSrc} type="video/mp4"/>
                        Your browser does not support the video tag.
                    </video>
                ) : (
                    <VideoPlayer/>
                ))}
            </div>
        </div>
    );
};

export default Section00;
